import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";

import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";
import type InviteMspDto from "./dto/invite-msp.dto";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { BASE_API_PATHS } from "../../../constants/apis.constants";
import { ReducerMethods } from "../../store/reducer.methods";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";

export const MSPInviteEffectActions = {
  inviteMSP: `${Entities.MspInvite}_inviteMSP`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.MspInvite,
  initSchema,
  aliasName: DIContainerKeys.MspInviteService,
})
export class MspInviteService extends HttpService {
  @loader(Loaders.MspInviteLoader)
  @flagger(Flaggers.MspInviteFlagger)
  @action(DIContainerKeys.MspInviteService)
  public *inviteMSP(dto: InviteMspDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.MspInviteLoader, true);
    const response = yield call(
      this.post,
      {
        url: BASE_API_PATHS.inviteMSP,
        body: this.toFormData({
          CompanyName: dto.companyName,
          FullName: dto.userName,
          EmailAddress: dto.companyEmail,
          Country: dto.country,
        }),
      },
      ReducerMethods.UPDATE
    );
    yield this.setLoaderState(Loaders.MspInviteLoader, false);
    if (!response?.Success) {
      CallToast(response?.Message, false, false, "v2style");
      return;
    }
    yield this.setFlaggerState(Flaggers.MspInviteFlagger, null);
    if (dto.callback) {
      dto.callback();
    }
  }
}